import {
    ActiveRetentionPolicyRowType,
    AvailableRetentionPolicyRowType,
} from '../store/schema/RetentionPolicyRowType';
import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';
import RetentionActionType from 'owa-service/lib/contract/RetentionActionType';
import strings from 'owa-strings/owa-options-strings';
import { format } from 'owa-strings';
import ElcFolderType from 'owa-service/lib/contract/ElcFolderType';
import { getRetentionDuration } from 'owa-retention-policies-common';

/**
 * Obtain the needed data needed for component from the retention policy tag display info
 * @param tag the retention policy tag info for display
 */
export default function extractRetentionPolicyInfo(
    tag: RetentionPolicyTagDisplay
): ActiveRetentionPolicyRowType | AvailableRetentionPolicyRowType {
    const retentionActionDescription = getRetentionActionDescription(tag);
    const retentionDuration = getRetentionDuration(tag);
    const typeDescription = getTypeDescription(tag);
    const description = retentionDuration
        ? format(
              strings.options_retentionPolicies_policyDescriptionWithDurationText,
              retentionActionDescription,
              retentionDuration,
              typeDescription
          )
        : format(
              strings.options_retentionPolicies_policyDescriptionWithoutDurationText,
              retentionActionDescription,
              typeDescription
          );
    return {
        isChecked: false,
        description: description,
        ...tag,
    };
}

export function getTypeDescription({
    OptionalTag: optionalTag,
    Type: type,
}: RetentionPolicyTagDisplay): string {
    return optionalTag
        ? ''
        : type == ElcFolderType.All
        ? strings.options_retentionPolicies_defaultRetentionTagDescriptionText
        : strings.options_retentionPolicies_retentionTypeRequiredDescriptionText;
}

export function getRetentionActionDescription({
    RetentionEnabled: retentionEnabled,
    RetentionAction: retentionAction,
}: RetentionPolicyTagDisplay): string {
    if (!retentionEnabled) {
        return retentionAction == RetentionActionType.MoveToArchive
            ? strings.options_retentionPolicies_actionNeverMoveText
            : strings.options_retentionPolicies_actionNeverDeleteText;
    }

    switch (retentionAction) {
        case RetentionActionType.MoveToDeletedItems:
            return strings.options_retentionPolicies_actionMoveToDeletedItemsText;
        case RetentionActionType.MoveToFolder:
            return strings.options_retentionPolicies_actionMoveToFolderText;
        case RetentionActionType.DeleteAndAllowRecovery:
            return strings.options_retentionPolicies_actionDeleteAndAllowRecoveryText;
        case RetentionActionType.PermanentlyDelete:
            return strings.options_retentionPolicies_actionPermanentlyDeleteText;
        case RetentionActionType.MarkAsPastRetentionLimit:
            return strings.options_retentionPolicies_actionMarkAsPastRetentionLimitText;
        case RetentionActionType.MoveToArchive:
            return strings.options_retentionPolicies_actionMoveToArchiveText;
        default:
            return '';
    }
}
